"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsCrime = void 0;
const statsCrimeGetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGet_js_1 = require("../funcs/statsCrimeGetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class StatsCrime extends sdks_js_1.ClientSDK {
    /**
     * Local Authority | Crime
     *
     * @remarks
     * This endpoint retrieves crime data for a specific local authority and its surrounding local authorities.
     */
    async getCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGet(security, localAuthorityCode, options) {
        return (0, fp_js_1.unwrapAsync)((0, statsCrimeGetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGet_js_1.statsCrimeGetCrimeByLocalAuthorityStatsCrimeCrimeByLocalAuthorityLocalAuthorityCodeGet)(this, security, localAuthorityCode, options));
    }
}
exports.StatsCrime = StatsCrime;
//# sourceMappingURL=statscrime.js.map